import { z } from 'zod/v4';

export const DownloadOrderDocumentsParamsSchema = z.object({
  orderId: z.string().min(1),
});

export const DownloadLinkDocumentsParamsSchema = z.object({
  linkId: z.string().min(1),
});

export const DownloadOrderDocumentsQuerySchema = z.object({
  type: z.enum(['PURCHASE_ORDER', 'SALES_ORDER']),
});

export type DownloadOrderDocumentsQuery = z.infer<
  typeof DownloadOrderDocumentsQuerySchema
>;

/**
 * Error codes the order and link documents downloads answer with, besides
 * `not_found`.
 */
export const DOWNLOAD_ORDER_DOCUMENTS_ERROR_CODES = {
  /** 404 — the order's trace, or the link, has no documents to zip. */
  NO_DOCUMENTS: 'file_not_found',
} as const;
